export const CARGAR_CLIENTE = 'CARGAR_CLIENTE';
export const SET_CLIENTE = 'SET_CLIENTE';
export const INICIALIZAR_CLIENTE = 'INICIALIZAR_CLIENTE';
export const CARGAR_CHEQUES = 'CARGAR_CHEQUES';
export const CARGAR_NOTACREDITO = 'CARGAR_NOTACREDITO';
export const CARGAR_NOTADEBITO = 'CARGAR_NOTADEBITO';
export const INICIALIZAR_NOTACREDITO = 'INICIALIZAR_NOTACREDITO';
export const INICIALIZAR_NOTADEBITO = 'INICIALIZAR_NOTADEBITO';
export const SELECCIONAR_NUMCOMPROBANTE = 'SELECCIONAR_NUMCOMPROBANTE';
export const CARGAR_GESTIONES_CLIENTE = 'CARGAR_GESTIONES_CLIENTE';
export const CARGAR_GESTIONESPLANIF_CLIENTE = 'CARGAR_GESTIONESPLANIF_CLIENTE';